// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3nmGw","ScrollX":"Scroll_ScrollX__2OCWr","ScrollY":"Scroll_ScrollY__kHsoK"};